import { BASE_API_URL } from './index';

export const convertToRegisteredEndpoint = `${BASE_API_URL}/signup/convert/`;
export const signupCreateAccountEndpoint = `${BASE_API_URL}/signup/`;
export const signupVerifyEmailEndpoint = `${BASE_API_URL}/signup/verify/`;
export const signupResendVerificationEmailEndpoint = `${BASE_API_URL}/signup/resend/`;
export const signupSelectNamespaceEndpoint = `${BASE_API_URL}/signup/namespace/`;
